import { Box, Typography } from '@mui/material';
import type {
  DependencyCode,
  IncomeCode,
  IncomeSourceCode,
  RatioCode,
  SuitabilityAnswers,
} from './answers';
import { RadioQuestion } from 'src/suitability/engine/components/radio-question';
import { useWioCapitalContent } from './content';

interface StepProps {
  answers: SuitabilityAnswers;
  onUpdate: (patch: Partial<SuitabilityAnswers>) => void;
}

// v1 solo PF — los tramos PJ existen en el catálogo pero no se usan aún.
export const StepBlock3 = ({ answers, onUpdate }: StepProps) => {
  const content = useWioCapitalContent();
  const step = content.step('block3');

  return (
    <Box>
      <Typography variant="textXl" sx={{ fontWeight: 700, mb: 1 }}>
        {step.title}
      </Typography>
      <Typography
        variant="textSm"
        sx={{ color: 'text.secondary', mb: 3, display: 'block' }}
      >
        {step.intro}
      </Typography>

      <RadioQuestion
        question={content.radio('p12').prompt}
        options={content.radio('p12').options}
        value={answers.p12}
        onChange={(v) => onUpdate({ p12: v as IncomeCode })}
        required
      />
      <RadioQuestion
        question={content.radio('p13').prompt}
        options={content.radio('p13').options}
        value={answers.p13}
        onChange={(v) => onUpdate({ p13: v as RatioCode })}
        required
      />
      <RadioQuestion
        question={content.radio('p14').prompt}
        options={content.radio('p14').options}
        value={answers.p14}
        onChange={(v) => onUpdate({ p14: v as IncomeSourceCode })}
        required
      />
      <RadioQuestion
        question={content.radio('p15').prompt}
        options={content.radio('p15').options}
        value={answers.p15}
        onChange={(v) => onUpdate({ p15: v as DependencyCode })}
        required
      />
    </Box>
  );
};
